module.exports = __webpack_public_path__ + "img/horizontal_4_4_5012.3184ab85.png";